import { makeStyles } from "@material-ui/core/styles";
import loginCTAImage from "assets/ipadbg.jpg";

export const useStyles = makeStyles(() => ({
  loginCTABG: {
    backgroundImage: "url(" + loginCTAImage + ")",
    backgroundSize: "cover",
    bacgroundPosition: "center center",
    "@media (max-width: 1136px)": {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  loginCTA: {
    padding: '40px',
    backgroundColor:'#0058bda3',
    height: '100%',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    "@media (max-width: 1136px)": {
      padding: '90px 90px 50px 90px'
    }
  },
  ctaSectionHeader: {
    color: "white", 
    fontSize: "35px",
    width: '550px',
    lineHeight: "50px",
    margin: '0 auto',
    textAlign: 'center',
    "@media (max-width: 1136px)": {
      width: '100%'
    }
  },
  ctaSectionWrapper: {
    margin: '0 auto',
    backgroundColor: 'white',
    "@media (max-width: 1136px)": {
      maxWidth: '100%',
      flexBasis: '100%'
    }
  },
  advertisement: {
    textAlign: 'right',
    "@media (max-width: 1136px)": {
      display: 'none'
    }
  },
  ctaSectionText: {
    color: "white",
    fontSize: "14px",
    width: '550px',
    margin: '25px auto 0',
    textAlign: 'center',
    "@media (max-width: 1136px)": {
      width: '100%'
    }
  },
  ctaButtonsWrapper: {
    margin: '35px auto',
    display: 'flex',
    justifyContent: 'center',
    '& button': {
      marginLeft: '20px',
      marginRight: '20px',
      width: '240px'
    },
    "@media (max-width: 1136px)": {
      flexDirection: 'column',
      '& button': {
        marginBottom: '35px'
      }
    }
  }
}));